<template>
  <v-card outlined class="plantillas-panel">
    <div class="panel-header">
      <div>
        <div class="panel-title">
          Plantillas
        </div>

        <div class="panel-subtitle">
          Selecciona una plantilla para llenar la factura
        </div>
      </div>

      <v-chip small label color="primary" text-color="white" class="panel-chip">
        {{ plantillasFiltradas.length }}
      </v-chip>
    </div>

    <v-divider />

    <v-card-text class="panel-content">
      <v-text-field
        v-model="search"
        dense
        outlined
        clearable
        hide-details
        prepend-inner-icon="mdi-magnify"
        label="Buscar plantilla"
        class="search-field"
      />

      <div v-if="!plantillasFiltradas.length" class="empty-state">
        <v-icon size="44" color="grey lighten-1">
          mdi-file-search-outline
        </v-icon>

        <div class="empty-title">
          No hay plantillas
        </div>

        <div class="empty-text">
          No se encontraron plantillas con ese criterio.
        </div>
      </div>

      <v-row v-else dense class="mt-2">
        <v-col
          v-for="(item, index) in plantillasFiltradas"
          :key="getKey(item, index)"
          cols="12"
  sm="6"
  md="6"
  lg="6"
        >
  <v-card
  outlined
  hover
  role="button"
  tabindex="0"
  class="card-plantilla mini-factura mini-view"
  :class="{ 'card-plantilla--selected': esSeleccionada(item) }"
  :aria-pressed="esSeleccionada(item)"
  @click="seleccionar(item)"
  @keydown.enter="seleccionar(item)"
  @keydown.space.prevent="seleccionar(item)"
>
  <div class="mini-strip">
    <span>Factura</span>
    <strong>{{ formatearMoneda(item.total) }}</strong>
  </div>

  <v-card-text class="mini-content">
    <div class="mini-header">
      <div class="mini-title-wrap">
        <div class="mini-title" :title="item.nombre">
          {{ item.nombre || 'Plantilla sin nombre' }}
        </div>

        <div class="mini-desc" :title="item.descripcionProducto">
          {{ item.descripcionProducto || 'Sin descripción' }}
        </div>
      </div>

      <v-avatar
        size="24"
        class="mini-icon"
        :color="esSeleccionada(item) ? 'primary' : 'white'"
      >
        <v-icon
          x-small
          :color="esSeleccionada(item) ? 'white' : 'grey darken-1'"
        >
          {{ esSeleccionada(item) ? 'mdi-check' : 'mdi-receipt-text-outline' }}
        </v-icon>
      </v-avatar>
    </div>

    <div class="mini-divider" />

    <div class="mini-grid">
      <div class="mini-info">
        <span>RFC</span>
        <strong :title="item.rfc">
          {{ item.rfc || 'N/A' }}
        </strong>
      </div>

      <div class="mini-info">
        <span>CP</span>
        <strong :title="item.cp">
          {{ item.cp || 'N/A' }}
        </strong>
      </div>

      <div class="mini-info">
        <span>Clave</span>
        <strong :title="item.claveProducto">
          {{ item.claveProducto || 'N/A' }}
        </strong>
      </div>

      <div class="mini-info">
        <span>Unidad</span>
        <strong :title="item.unidad">
          {{ item.unidad || 'N/A' }}
        </strong>
      </div>
    </div>

    <div class="mini-footer">
      <v-chip
        x-small
        label
        color="white"
        text-color="grey darken-3"
        class="mini-chip"
      > Forma pago:
        {{ item.formaPago || 'Sin forma de pago' }}
      </v-chip>
    </div>
  </v-card-text>
</v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'PlantillasCards',

  props: {
    plantillas: {
      type: Array,
      default: () => []
    },

    plantillaSeleccionada: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      search: ''
    };
  },

  computed: {
    plantillasFiltradas() {
      const texto = String(this.search || '').toLowerCase().trim();

      if (!texto) {
        return this.plantillas;
      }

      return this.plantillas.filter(item => {
        const campos = [
          item.nombre,
          item.descripcionProducto,
          item.claveProducto,
          item.rfc,
          item.cp,
          item.unidad,
          item.formaPago
        ];

        return campos.some(campo =>
          String(campo || '').toLowerCase().includes(texto)
        );
      });
    }
  },

  methods: {
    seleccionar(item) {
      this.$emit('seleccionar', item);
    },

    esSeleccionada(item) {
      if (!this.plantillaSeleccionada || !item) {
        return false;
      }

      return this.plantillaSeleccionada.id === item.id;
    },

    getKey(item, index) {
      return item.id || item.plantillaId || index;
    },

    formatearMoneda(valor) {
      const numero = Number(valor || 0);

      return numero.toLocaleString('es-MX', {
        style: 'currency',
        currency: 'MXN'
      });
    }
  }
};
</script>

<style scoped>
.plantillas-panel {
  border-radius: 18px;
  border-color: #e5e7eb;
  background: #ffffff;
  overflow: hidden;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px;
}

.panel-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #111827;
  line-height: 1.2;
}

.panel-subtitle {
  margin-top: 3px;
  font-size: 0.76rem;
  color: #6b7280;
}

.panel-chip {
  font-weight: 700;
  min-width: 34px;
  justify-content: center;
}

.panel-content {
  padding: 16px 18px 18px;
}

.search-field {
  margin-bottom: 10px;
}

::v-deep .search-field .v-input__slot {
  border-radius: 12px;
  background: #fafafa;
}

.card-plantilla {
  height: 100%;
  cursor: pointer;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
  overflow: hidden;
}

.card-plantilla.mini-factura {
  min-height: auto;
}
.card-plantilla.mini-view {
  position: relative;
  min-height: 172px;
  border-radius: 14px;
  border: 1px solid #bfd7f3 !important;
  background: linear-gradient(180deg, #edf6ff 0%, #ffffff 58%, #fff9ec 100%) !important;
  overflow: hidden;
}

.card-plantilla.mini-view::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at top right, rgba(25, 118, 210, 0.13), transparent 34%),
    linear-gradient(135deg, rgba(25, 118, 210, 0.06), transparent 50%);
  pointer-events: none;
  z-index: 0;
}



.mini-strip {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 7px 10px;
  background: rgba(25, 118, 210, 0.13);
  border-bottom: 1px dashed #93c5fd;
  color: #174ea6;
  font-size: 0.62rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.035em;
}

.mini-strip strong {
  font-size: 0.68rem;
  font-weight: 900;
  white-space: nowrap;
}

.mini-content {
  position: relative;
  z-index: 1;
  padding: 10px !important;
  background: transparent !important;
}

.mini-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.mini-title-wrap {
  min-width: 0;
}

.mini-title {
  font-size: 0.78rem;
  font-weight: 800;
  color: #334155;
  line-height: 1rem;
  min-height: 2rem;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.mini-desc {
  margin-top: 3px;
  font-size: 0.67rem;
  font-weight: 500;
  color: #64748b;
  line-height: 0.9rem;
  min-height: 1.8rem;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.mini-icon {
  flex: 0 0 auto;
  border: 1px solid rgba(148, 163, 184, 0.25);
}

.mini-divider {
  margin: 9px 0;
  border-top: 1px dashed #cbd5e1;
}

.mini-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px 9px;
}

.mini-info {
  min-width: 0;
}

.mini-info span {
  display: block;
  margin-bottom: 2px;
  font-size: 0.55rem;
  font-weight: 800;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.035em;
}

.mini-info strong {
  display: block;
  font-size: 0.68rem;
  font-weight: 800;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mini-footer {
  margin-top: 9px;
}

.mini-chip {
  max-width: 100%;
  border: 1px solid #e2e8f0;
  font-size: 0.6rem;
  font-weight: 700;
}

::v-deep .mini-chip .v-chip__content {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card-plantilla.mini-view:hover {
  transform: translateY(-2px);
  border-color: #1976d2 !important;
  box-shadow: 0 10px 22px rgba(25, 118, 210, 0.16);
}

.card-plantilla.mini-view.card-plantilla--selected {
  border-color: #1976d2 !important;
  background: linear-gradient(180deg, #dceeff 0%, #ffffff 58%, #fff3d6 100%) !important;
  box-shadow: 0 8px 20px rgba(25, 118, 210, 0.18);
}

@media (max-width: 960px) {
  .card-plantilla.mini-view {
    min-height: 165px;
  }
}

@media (max-width: 600px) {
  .card-plantilla.mini-view {
    min-height: auto;
  }
}
.factura-strip {
  padding: 7px 14px;
  font-size: 0.62rem;
}

.card-content {
  padding: 12px 14px;
}

.plantilla-nombre {
  font-size: 0.86rem;
  line-height: 1.15rem;
  word-break: normal;
  overflow-wrap: normal;

  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.plantilla-descripcion {
  font-size: 0.72rem;
  line-height: 1rem;
  margin-top: 3px;
  word-break: normal;
  overflow-wrap: normal;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.info-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin-top: 10px;
}

.info-label {
  font-size: 0.58rem;
}

.info-value {
  font-size: 0.7rem;
}

.card-footer {
  margin-top: 10px;
  padding-top: 9px;
}

.plantilla-total {
  font-size: 0.86rem;
}

.card-plantilla.mini-factura::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at top right, rgba(25, 118, 210, 0.14), transparent 34%),
    linear-gradient(135deg, rgba(25, 118, 210, 0.08), transparent 45%);
  z-index: 0;
  pointer-events: none;
}



.factura-strip {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 9px 14px 8px 18px;
  background: rgba(25, 118, 210, 0.14);
  border-bottom: 1px dashed #90caf9;
  font-size: 0.66rem;
  font-weight: 800;
  color: #0d47a1;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.card-content {
  position: relative;
  z-index: 1;
  padding: 14px 14px 15px 18px;
  background: transparent !important;
}

.card-plantilla.mini-factura:hover {
  transform: translateY(-2px);
  border-color: #1976d2 !important;
  box-shadow: 0 12px 28px rgba(25, 118, 210, 0.18);
}

.card-plantilla.mini-factura.card-plantilla--selected {
  border-color: #1976d2 !important;
  background: linear-gradient(180deg, #dff0ff 0%, #ffffff 48%, #fff4d6 100%) !important;
  box-shadow: 0 10px 26px rgba(25, 118, 210, 0.18);
  }

.card-content {
  position: relative;
  z-index: 1;
  padding: 14px 14px 15px 18px;
}

.card-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.card-main {
  min-width: 0;
}

.card-icon {
  flex: 0 0 auto;
  border: 1px solid rgba(148, 163, 184, 0.24);
}

.factura-line {
  margin-top: 14px;
  border-top: 1px dashed #cbd5e1;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 12px;
  margin-top: 14px;
}

.info-label {
  display: block;
  margin-bottom: 2px;
  font-size: 0.62rem;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.info-value {
  display: block;
  font-size: 0.76rem;
  font-weight: 600;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px dashed #cbd5e1;
}

.payment-chip {
  max-width: 145px;
  font-weight: 600;
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

::v-deep .payment-chip .v-chip__content {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.plantilla-total {
  flex: 0 0 auto;
  font-size: 0.94rem;
  font-weight: 800;
  color: #047857;
  white-space: nowrap;
  letter-spacing: -0.01em;
}
.empty-state {
  margin-top: 12px;
  padding: 38px 22px;
  text-align: center;
  border: 1px dashed #d1d5db;
  border-radius: 16px;
  background: #fafafa;
}

.empty-title {
  margin-top: 12px;
  font-size: 0.92rem;
  font-weight: 700;
  color: #374151;
}

.empty-text {
  margin-top: 4px;
  font-size: 0.76rem;
  color: #6b7280;
}

@media (max-width: 600px) {
  .plantillas-panel {
    border-radius: 14px;
  }

  .panel-header {
    padding: 16px;
  }

  .panel-content {
    padding: 14px;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .card-footer {
    align-items: flex-start;
    flex-direction: column;
  }

  .payment-chip {
    max-width: 100%;
  }

  .plantilla-total {
    font-size: 1rem;
  }
}
</style>